import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HybridAdapterUtility } from '../../Hybrid/hybrid-adapter.utility';
import { AgGridModule } from 'ag-grid-angular';
import { WeissmanSharedModule } from '../../Common/weissman-shared.module';
import { SharedPipesModule } from '../../UI-Lib/Pipes/shared-pipes.module';
import { BusyIndicatorModule } from '../../Busy-Indicator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { LeadDocketLogService } from './leadDocketLog.service';
import { LeadDocketLogRepository } from './leadDocketLog.repository';
import { LeadDocketLogListComponent } from './Lead-Docket-Log-List/leadDocketLogList.component';
import { LeadDocketLogListGridActionCellRendererComponent } from './Lead-Docket-Log-List/agGridActionCellRenderer.component';
import { LeadDocketLogDetailsModalComponent } from './Lead-Docket-Log-Details/leadDocketLogDetailsModal.component';
import { LeadDocketLogDetailsGridComponent } from './Lead-Docket-Log-Details/leadDocketLogDetailsGrid.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WeissmanSharedModule,
        SharedPipesModule,
        BusyIndicatorModule.forRoot(),
        AgGridExtensionsModule,
        AgGridModule
    ],
    declarations: [
        LeadDocketLogListComponent,
        LeadDocketLogListGridActionCellRendererComponent,
        LeadDocketLogDetailsModalComponent,
        LeadDocketLogDetailsGridComponent
    ],
    providers: [
        LeadDocketLogService,
        LeadDocketLogRepository
    ],
    exports: []
})
export class LeadDocketLogModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('leadDocketLogList', LeadDocketLogListComponent);
        hybridAdapterUtility.downgradeNg2Component('leadDocketLogDetails', LeadDocketLogDetailsModalComponent);
        hybridAdapterUtility.downgradeNg2Component('leadDocketLogDetailsGrid', LeadDocketLogDetailsGridComponent);
    }
}
